import { forwardRef } from "react";

import { Button, CopyIcon, useToast } from "..";
import { ClipboardCopyButtonProps } from "./type";
import { copyToClipboard } from "./utils";

export const ClipboardCopyButton = forwardRef<HTMLButtonElement, ClipboardCopyButtonProps>(
  ({ copyText, copyTextTitle }, ref) => {
    const { openToast } = useToast();

    return (
      <Button
        ref={ref}
        icon={<CopyIcon className="fill-ui-300" />}
        iconType="only"
        styleType="textLine"
        onClick={() =>
          copyToClipboard({
            value: copyText,
            onSuccess: () =>
              openToast({ description: copyTextTitle ? `${copyTextTitle}をコピーしました` : "コピーしました" }),
          })
        }
      />
    );
  },
);

ClipboardCopyButton.displayName = "ClipboardCopyButton";
